import { Steps } from "./health-foreigners-hire-menu-types";

export class ForeignersHealthHireMenuHelper {
  static getStepFromNavigationRoute(path: string): Steps {
    if (path.indexOf("/contratacion/nueva/health/tomador") !== -1) return Steps.DatosTomador;
    else if (path.indexOf("/contratacion/nueva/health/asegurados") !== -1)
      return Steps.DatosAsegurados;
    else if (path.indexOf("/contratacion/nueva/health/garantias") !== -1) return Steps.Garantias;
    else if (path.indexOf("/contratacion/nueva/health/documentacion-requerida") !== -1)
      return Steps.DocumentacionRequerida;
    else if (path.indexOf("/contratacion/nueva/health/proteccion-datos") !== -1)
      return Steps.ProteccionDatos;
    else if (path.indexOf("/contratacion/nueva/health/precio") !== -1) return Steps.Prima;
    else if (path.indexOf("/contratacion/nueva/health/cuestionarios-salud") !== -1)
      return Steps.Cuestionarios;
    else if (path.indexOf("/contratacion/nueva/health/medios-pago") !== -1)
      return Steps.MetodosPago;
    else if (path.indexOf("/contratacion/nueva/health/resultado") !== -1)
      return Steps.DetallePrevioContratacion;
    else return Steps.DatosTomador;
  }

  static getStepNavigationPath(step: Steps, insuredsLength: number): string {
    let currentInsured = insuredsLength - 1;
    currentInsured = currentInsured < 0 ? 0 : currentInsured;
    switch (step) {
      case Steps.DatosTomador:
        return "/contratacion/nueva/health/tomador";
      case Steps.DatosAsegurados:
        return insuredsLength === 0
          ? "/contratacion/nueva/health/asegurados/"
          : `/contratacion/nueva/health/asegurados/${currentInsured}`;
      case Steps.Garantias:
        return "/contratacion/nueva/health/garantias";
      case Steps.DocumentacionRequerida:
        return "/contratacion/nueva/health/documentacion-requerida";
      case Steps.ProteccionDatos:
        return "/contratacion/nueva/health/proteccion-datos";
      case Steps.Prima:
        return "/contratacion/nueva/health/precio";
      case Steps.Cuestionarios:
        return "/contratacion/nueva/health/cuestionarios-salud/0";
      case Steps.MetodosPago:
        return "/contratacion/nueva/health/medios-pago";
      case Steps.DetallePrevioContratacion:
        return "/contratacion/nueva/health/resultado";
      default:
        return "";
    }
  }

  static getPreviousStep(currentStep: Steps): Steps {
    try {
      return currentStep - 1;
    } catch {
      return Steps.DatosTomador;
    }
  }

  static getPreviousStepNavigationPath(currentStep: Steps): string {
    return this.getStepNavigationPath(this.getPreviousStep(currentStep), 1);
  }

  static getNextStep(currentStep: Steps): Steps {
    try {
      return currentStep + 1;
    } catch {
      return Steps.DetallePrevioContratacion;
    }
  }

  static getNextStepNavigationPath(currentStep: Steps): string {
    return this.getStepNavigationPath(this.getNextStep(currentStep), 1);
  }
}
